import { render, staticRenderFns } from "./ArchivesViewerTabContent.vue?vue&type=template&id=3578aef4&"
import script from "./ArchivesViewerTabContent.vue?vue&type=script&lang=js&"
export * from "./ArchivesViewerTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports